<template>
  <div class="d-flex justify-content-center align-items-center SpinnerLoader" v-if="!hidden">
    <img width="170" src="/img/loading.gif">
  </div>
</template>

<script>
export default {
  name: 'SpinnerLoader',
  data () {
    return {
      hidden: true
    }
  },
  methods: {
    show () {
      this.hidden = false
    },
    hide () {
      this.hidden = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .SpinnerLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #ffffff;
    z-index: 1050;
  }
</style>
